import { hDeepCopy } from '@/utils/helpers';
import validator from 'validator';

// @vue/component
export default {
  name: 'AgentDetailsAndEditForm',

  props: {
    agentUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isAutocompletedLoading: false,
      agent: {},
      helpDeskNumbers: [],
      prefix: '48',
      rules: {
        nr_tel: [
          { required: true, validator: this.__validateNumber, trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/agents/getDetails',
        'client/project/agents/updateAgent',
        'client/project/getHelpdeskNumbersForProject',
      ]);
    },
    groupsList() {
      return this.$store.getters['client/project/agentsGroups/list'].records;
    },
  },

  watch: {
    'agent.id_postal_code': {
      async handler(newValue) {
        if (newValue?.length === 6 && newValue !== '00-000' && newValue.indexOf('_') === -1) {
          this.isAutocompletedLoading = true;
          const detailsByPostcode = await this.$store.dispatch('global/getProvince', newValue);
          this.isAutocompletedLoading = false;
          this.agent.city = detailsByPostcode?.city;
        }
      },
      deep: true,
    },
  },

  async created() {
    await this.$store.dispatch('client/project/agents/getDetails', this.agentUuid);
    this.__prepareData();
    this.__fixPostalCode();
  },

  methods: {
    __fixPostalCode() {
      if (!this.agent.id_postal_code) {
        this.agent.id_postal_code = (String(this.agent.id_postal_code)).padStart(5, '0');
      }
    },
    async __prepareData() {
      this.agent = await hDeepCopy(this.$store.getters['client/project/agents/details'].record);
      this.helpDeskNumbers = await this.$store.dispatch('client/project/getHelpdeskNumbersForProject', this.agent.project_uuid);
      this.prefix = this.agent.nr_tel.substr(0, 2);
      this.agent.nr_tel = this.agent.nr_tel.substr(2);
      delete this.agent.work_day;
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    async submitForm() {
      if (!this.agent.user_uuid) delete this.agent.user_uuid;
      const { agentForm } = this.$refs;
      agentForm.validate(async (valid) => {
        if (!valid) return;
        const params = {
          ...this.agent,
          nr_tel: this.prefix + this.agent.nr_tel,
          old_nr_tel: this.$store.getters['client/project/agents/details'].record.nr_tel,
          id_postal_code: this.agent.id_postal_code !== '' ? (String(this.agent.id_postal_code)).replace('-', '') : null,
        };
        await this.$store.dispatch('client/project/agents/updateAgent', {
          ...params,
          agent: this.agent.uuid,
        });
        this.$message({
          type: 'success',
          message: 'Edycja agenta/placówki przebiegła pomyślnie',
        });
        this.$store.dispatch('client/project/agents/getList', { project: this.agent.project_uuid });
        this.closeModal();
      });
    },
    closeModal() {
      this.$emit('closeModal');
    },
    __validateNumber(rule, value, callback) {
      if (!value) {
        callback('Pole obowiązkowe.');
        return;
      }
      if (this.prefix === '48' && !validator.isLength(value, { min: 9, max: 9 })) {
        callback('Numer krajowy musi mieć 9 znaków.');
        return;
      }
      if (this.prefix === '00' && !validator.isLength(value, { min: 11, max: 13 })) {
        callback('Numer międzynarodowy musi się zawierać w przedziale 11-13 znaków.');
        return;
      }
      callback();
    },
  },
};
